
import {AccountState} from "../constants";
import {adminSendConfirmationEmail, sendConfirmationEmail} from "../../client/onboarding/actions";
import {deep_copy} from "../js-utils";
import {is_transfer} from "../onboarding-utils";

/**
 * The steps to go from SIGNED to LIVE are spread across too many
 * React components. They should live here in a single place
 */
class GoLiveController {
  constructor(component) {
    this.component = component;
  }

  goLive = () => {
    return new Promise((resolve, reject) => {
      const account_state = this.component.getAccountState();
      const set_live_state = account_state !== AccountState.LIVE;
      console.log("goLive account_state", account_state, "set_live_state", set_live_state);
      const args = this.component.getPathArgs();
      const onboarding = this.component.getOnboardingData();
      const is_proxy_onboarding = args.account_state === AccountState.ONBOARDING_PROXY;
      const do_onboarding_transfer = is_transfer(onboarding);

      this.component.setState({
        is_sending_email: true,
        going_live: true,
      });

      const email_promise = is_proxy_onboarding
        ? adminSendConfirmationEmail(
          this.component.props.token,
          this.component.getOnboardingIndex(),
          set_live_state,
          args.username)
        : sendConfirmationEmail(
          this.component.props.token,
          this.component.props.onboarding_token,
          this.component.getOnboardingIndex(),
          set_live_state);

      email_promise.then(result => {
        this.component.setState({
          is_sending_email: false,
          going_live: false,
        });
        const data = result.body.data;
        if (args.account_state && args.account_state !== data.account_state) {
          const new_args = deep_copy(args);
          new_args.account_state = data.account_state;
          console.log("navigate", this.component.props.path, new_args);
          this.component.props.navigatePath(this.component.props.path, new_args);
        }

        if (data.success) {
          if (data.account_state) {
            this.component.props.setAccountState(
              data.account_state, data.index);
          }
          if (data.onboarding) {
            this.component.props.setOnboardingData(
              data.onboarding, data.index);
          }
          if (do_onboarding_transfer) {
            this.component.onGoLive(is_proxy_onboarding).then();
          }
        }
      });

      return resolve();
    })
  }
}

export { GoLiveController };
